export const MODAL_LEFT_ACTION_SIZE = 50;
